// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609150903/js/" + chunkId + "." + {"44":"6586b3e0","225":"163509c1","481":"c5c0d5cf","486":"1f206e9a","770":"61632720"}[chunkId] + ".0.39498702719028367.chunk.js";
};